import React, {
    useMemo,
    useContext
} from 'react';
import _ from 'lodash';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';

import { wizardProps, WizardPageHeader } from 'e1p-portals-wizard-react';
import { AmfamOktaTokenContext } from 'e1p-capability-gateway-react';
import { useTranslator } from '@jutro/locale';
import { commonMessages } from 'e1p-platform-translations';
import styles from './ThankYouPage.module.scss';
import metadata from './ThankYouPage.metadata.json5';
import './ThankYouPage.messages';

const LOB = 'homeowners_EH';

function ThankYouPage(props) {
    const { wizardData: rewriteVM } = props;

    const viewModelService = useContext(ViewModelServiceContext);

    const policyNumber = useMemo(() => _.get(rewriteVM, 'bindData.policyNumber.value'), [rewriteVM]);

    const onPrintHandler = () => {
        window.print();
    };

    const translator = useTranslator();
    const { opCo } = useContext(AmfamOktaTokenContext);

    const overrideProps = {
        '@field': {
            labelPosition: 'top',
            autoComplete: false
        },
        exitToDashBoardButtonId: {
            to: `/policies/${policyNumber}/summary`
        },
        messagesContainer: {
            submissionVM: rewriteVM,
            viewModelService,
            LOB
        },
        policyDocumentContainer: {
            submissionVM: rewriteVM
        },
        addANewLineComponent: {
            submissionVM: rewriteVM
        },
        requiredDocumentContainer: {
            submissionVM: rewriteVM,
            viewModelService
        },
        wizardHeaderContainer: {
            wizardSubmission: rewriteVM,
            isSideHeader: false,
            shouldLink: false,
            isPolicyView: false
        },
        thankyouMessageLabelId: {
            content: opCo === 'MSA' ? translator(commonMessages.thankYouMessage, { partner: translator(commonMessages.msa) })
                : translator(commonMessages.thankYouMessage, { partner: translator(commonMessages.connect) })
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            wizardpageheader: WizardPageHeader
        },
        resolveCallbackMap: {
            onPrintHandler
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={rewriteVM}
            overrideProps={overrideProps}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
            callbackMap={resolvers.resolveCallbackMap}
        />
    );
}

ThankYouPage.propTypes = wizardProps;
export default ThankYouPage; 
